__turbopack_context__.v({
  "chip": "_5YBOlW_chip",
  "chips": "_5YBOlW_chips",
  "introduction": "_5YBOlW_introduction",
  "overline": "_5YBOlW_overline",
  "suggestions": "_5YBOlW_suggestions",
});
